import { Sparkles, type LucideIcon } from 'lucide-react';

export const spotlightData = [
  {
    bgColor: '#CEF0FF',
    title: "Don't wait to unlock your child's potential.",
    description:
      'Apply now and become part of our exceptional learning community!',
    imageSrc: '/static/images/spotlight.svg',
    buttons: [
      { text: 'Contact Us', variant: 'default', href: '/contact' },
      {
        text: 'Chat With AI',
        variant: 'outline',
        href: '/chat',
        icon: Sparkles,
      },
    ],
  },
  {
    bgColor: '#F4E1D1',
    title: 'Personalized Learning Paths for Every Student',
    description:
      "AI-powered education tailored to your child's unique strengths and learning style.",
    imageSrc: '/static/images/spotlight.svg',
    buttons: [
      { text: 'Contact Us', variant: 'default', href: '/contact' },
      {
        text: 'Chat With AI',
        variant: 'outline',
        href: '/chat',
        icon: Sparkles,
      },
    ],
  },
  {
    bgColor: '#FEE2E2',
    title: 'Future-Ready Education Starts Here',
    description:
      'Prepare for tomorrow with cutting-edge curriculum and expert mentorship programs.',
    imageSrc: '/static/images/spotlight.svg',
    buttons: [
      { text: 'Contact Us', variant: 'default', href: '/contact' },
      {
        text: 'Chat With AI',
        variant: 'outline',
        href: '/chat',
        icon: Sparkles,
      },
    ],
  },
] satisfies Array<{
  buttons: Array<{
    text: string;
    variant:
      | 'default'
      | 'outline'
      | 'secondary'
      | 'destructive'
      | 'ghost'
      | 'link';
    href?: string;
    icon?: LucideIcon;
  }>;
  title: string;
  description: string;
  imageSrc: string;
  bgColor: string;
}>;
